import type { TicketPriorityI } from 'declarations/interfaces/ticketPriorities';

import { get } from './api';

export const getPrioritiesApi = async (): Promise<TicketPriorityI[]> => {
  const response = await get<TicketPriorityI[]>('/tickets/priorities');

  return response.data;
};
